<template>
    <div class="text-center" v-if="!is_data_ready">
        <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
    <div class="ftb_table_section" id="ftb_md_table" v-else-if="tables">
        <div class="current_league_score_table">
            <table class="league_score_table bg-white">
                <thead>
                <tr>
                    <th>
                        #
                    </th>
                    <th>
                        {{ $t("Teams") }}
                    </th>
                    <th class="details_player_hide_mobile">
                        GP
                    </th>
                    <th>
                        W
                    </th>
                    <th class="details_player_hide_mobile">
                        D
                    </th>
                    <th>
                        L
                    </th>
                    <th class="details_player_hide_mobile">
                        GF
                    </th>
                    <th class="details_player_hide_mobile">
                        GA
                    </th>
                    <th class="details_player_hide_mobile">
                        GD
                    </th>
                    <th>
                        PTS
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr :class="[table.team.id == teams.home_team || table.team.id == teams.away_team ? 'current_teams_table' : '']" v-for="table in tables" :key="table.place">
                    <td>
                        <span class="highlight-border"></span><!-- [style.background-color]="color"-->
                        {{table.place}}
                    </td>
                    <td>
                      <div class="current_league_score_table_teamlogo">
                        <img class="details_player_hide_mobile" :onerror="$teamDefaultLogo()" :src="$storageURL+'images/football/'+table.team.id+'_90x90.webp'" alt="team logo">
                          {{table.team.name}}
                      </div>
                    </td>
                    <td class="details_player_hide_mobile">
                        {{table.played}}
                    </td>
                    <td>
                        {{table.won}}
                    </td>
                    <td class="details_player_hide_mobile" >
                        {{table.draws}}
                    </td>
                    <td>
                        {{table.lost}}
                    </td>
                    <td class="details_player_hide_mobile">
                        {{table.scored}}
                    </td>
                    <td class="details_player_hide_mobile">
                        {{table.conceded}}
                    </td>
                    <td class="details_player_hide_mobile">
                        {{table.difference}}
                    </td>
                    <td>
                        {{table.points}}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
	export default {
		name: 'MatchDetailTable',
		data() {
			return {
				tables: null,
				matchInfo: null,
				teams: {
					home_team: '',
					away_team: ''
				},
				is_data_ready: false,
			};
		},
		mounted() {
			this.getMatchDetail();
			this.getTableData();
		},
		serverPrefetch() {
			this.getMatchDetail();
			this.getTableData();
		},
		metaInfo() {
			let ss = this.$store.state.siteSetting;
			if (this.$store.state.fbMatchDetailResponse && this.$store.state.fbMatchDetailResponse.data) {
				const replacements = {
					'%TOURNAMENT_NAME%': this.$store.state.fbMatchDetailResponse.data.tournament.name,
				};

				let title = this.$getSafe(() => this.$replacePlaceHolders(ss.football_match_table_meta_title, replacements));
				let description = this.$getSafe(() => this.$replacePlaceHolders(ss.football_match_table_meta_description, replacements));
				let keywords = this.$getSafe(() => ss.football_match_table_meta_keywords);

				//let canonical = this.$toFullPath(this.$route.fullPath).replace('table', 'overview');;
				let canonical = this.$toFullPath(this.$route.fullPath);
				
				return {
					title: title,
					description: description,
					meta: this.$getMetaTags(title, description, keywords),
					link: [
						{ rel: 'canonical', href: canonical }
					]
				};
			}
		},
		jsonld() {
			if (isServer) {
				return {
				  "@context": "https://schema.org",
				  "@graph": []
				};
			}

			let events = [];
			if (this.matchInfo && this.tables) {
				const competitor1 = this.teams.home_team;
				const competitor2 = this.teams.away_team;
				const tournamentName = this.matchInfo.tournament.name;
				const matchDateTime = new Date(this.matchInfo.date);
				const matchDate = `${matchDateTime.getFullYear()}-${(matchDateTime.getMonth() + 1).toString().padStart(2, '0')}-${matchDateTime.getDate().toString().padStart(2, '0')}`;
				var tableTeams = [];
				if (this.tables.length !== 0) {
					tableTeams = this.tables.map(row => ({
					  "@type": "SportsTeam",
					  "name": row.team.name,
					  "url": row.team.url || row.team.logo
					}));
				}else{
					const matchTeams = this.matchInfo.competitors;
					var homeTeamId = matchTeams.filter(team => team.isHome)[0].id;
					var awayTeamId = matchTeams.filter(team => !team.isHome)[0].id;
					tableTeams = [
						{"@type": "SportsTeam","name": competitor1,"url": `https://cms.sabcsport.com/storage/images/football/${homeTeamId}_100x100.webp`},
						{"@type": "SportsTeam","name": competitor2,"url": `https://cms.sabcsport.com/storage/images/football/${awayTeamId}_100x100.webp`}
					];
				}

				events = {
				  "@context": "https://schema.org",
				  "@type": "WebPage",
				  "name": `${tournamentName} Standings`,
				  "description": `Updated standings for the ${tournamentName} ${this.matchInfo.tournament.season} season.`,
				  "url": `https://www.sabcsport.com/live/football/match-detail/${this.matchInfo.id}/tables`,
				  "mainEntity": {
					"@type": "SportsEvent",
					"name": `${tournamentName} ${this.matchInfo.tournament.season}`,
					"startDate": matchDate,
					"endDate": matchDate,
					"sport": "Soccer",
					"performer": tableTeams,
					"description": `Updated standings for the ${tournamentName} ${this.matchInfo.tournament.season} season.`,
				    "url": `https://www.sabcsport.com/live/football/match-detail/${this.matchInfo.id}/tables`,
				    "eventStatus": "https://schema.org/EventScheduled",
                    "image": this.$siteURL + 'public/images/logo.png',
					"organizer": {
						"@type": "Organization",
						"name": tournamentName,
						"url": this.$siteURL + "live/football/league-detail/" + this.$slugify(tournamentName) +'/'+ this.matchInfo.tournament.id +'/results',
					},
					"offers": {
						"@type": "Offer",
						"name": competitor1 + " VS " + competitor2,
						"url": this.$siteURL + "live/football/match-detail/" + this.$slugify(tournamentName +" "+ competitor1 + " VS " + competitor2) +'/'+ matchDate +'/'+ this.matchInfo.id +'/table',
						"priceCurrency": "EUR",
						"validFrom": matchDate,
						"availability": "https://schema.org/InStock",
						"price": "0"
					},
					"location": {
						"@type": "Place",
						"name": tournamentName,
						"address": {
							"@type": "PostalAddress",
							"name": '',
						}
					}
				  },
				};

				return events;
			}
		},
		methods: {
			getTableData() {
				this.is_data_ready = false;
				this.$axios.get(this.$FB_TABLE_API.replace(':match', this.$route.params.matchId))
					.then(response => {
						this.is_data_ready = true;
						this.tables = response.data.table;
					})
					.catch(error => {
						console.log(error);
						this.is_data_ready = true; // fallback to allow rendering
					});
			},
			getMatchDetail() {
				// Check if match data is already in Vuex store
				if (this.$store.getters.getFbMatchDetailResponse) {
					this.matchInfo = this.$store.getters.getFbMatchDetailResponse;
					const teams = this.matchInfo.competitors;
					this.teams.home_team = teams.filter(team => team.isHome)[0].name;
					this.teams.away_team = teams.filter(team => !team.isHome)[0].name;
				} else {
					// If data is not in store, fetch it directly
					this.$axios.get(this.$MATCH_FOOTBALL_DETAIL_API.replace(':match', this.$route.params.matchId))
						.then(response => {
							this.matchInfo = response.data.match;
							const teams = this.matchInfo.competitors;
							this.teams.home_team = teams.filter(team => team.isHome)[0].name;
							this.teams.away_team = teams.filter(team => !team.isHome)[0].name;
						})
						.catch(error => console.log(error));
				}
			}
		}
	};
</script>
